import React, { ReactNode } from 'react';
import Hero from 'components/organisms/Hero/Hero';
import HeroSignUpForm from 'components/organisms/Hero/HeroSignUpForm';
import LandingPageContent from 'components/organisms/LandingPageContent/LandingPageContent';
import LandingPageContentVanilla from 'components/organisms/LandingPageContent/LandingPageContentVanilla';

export interface Props {
  leftColumnContent: ReactNode;
  isVanillaText?: boolean;
}

const LandingPage: React.FC<Props> = ({ leftColumnContent, isVanillaText }) => {
  return (
    <main>
      <Hero leftColumnContent={<>{leftColumnContent}</>} rightColumnContent={<HeroSignUpForm />} />
      {isVanillaText ? <LandingPageContentVanilla /> : <LandingPageContent />}
    </main>
  );
};

export default LandingPage;
